import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles/index';
import { withRouter } from 'react-router-dom';
import { Table, TableHead, TableRow, TableCell, TableBody, IconButton, Icon, AppBar, Toolbar, Typography } from '@material-ui/core';
import * as Actions from './../store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const styles = theme => ({
    root: {}
});

class QuizGradeList extends Component {
    componentWillMount = () => {
        const instructor_id = this.props.auth.user.data.role_info.link_id;

        this.props.getQuizzesNotGraded(instructor_id);
    }

    handleRowClick = (student_quiz_id) => {
        this.props.history.push(`/quiz/grader/${student_quiz_id}`);
    }

    render() {
        const { quizNotGradedList, classes } = this.props;

        if (quizNotGradedList.length === 0) {
            return (
                <React.Fragment>
                    <AppBar position="static">
                        <Toolbar>
                            <Typography variant="h6" color="inherit">
                                Ungraded Quizzes Widget
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <Typography className={'text-center p-8'}>No Quizzes to Grade!</Typography>
                </React.Fragment>
            )
        }

        return (
            <React.Fragment>
                <AppBar position="static">
                    <Toolbar>
                        <Typography variant="h6" color="inherit">
                            Ungraded Quizzes Widget
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Student Name</TableCell>
                            <TableCell>Course</TableCell>
                            <TableCell>Quiz</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Grade</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {quizNotGradedList.map((student_quiz_info) => {
                            return (
                                <TableRow key={student_quiz_info.student_quiz_id}>
                                    <TableCell>{student_quiz_info.StudentName}</TableCell>
                                    <TableCell>{student_quiz_info.CourseName}</TableCell>
                                    <TableCell>{student_quiz_info.QuizName}</TableCell>
                                    <TableCell>{student_quiz_info.EndTime}</TableCell>
                                    <TableCell>
                                        <IconButton
                                            onClick={(ev) => {
                                                ev.stopPropagation();
                                                this.handleRowClick(student_quiz_info.student_quiz_id);
                                            }}
                                        >
                                            <Icon>assignment</Icon>
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </React.Fragment>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getQuizzesNotGraded: Actions.getQuizzesNotGraded
    }, dispatch);
}

function mapStateToProps({ dashboardApp, auth }) {
    return {
        quizNotGradedList: dashboardApp.widgets.quizNotGradedList,
        auth: auth,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(QuizGradeList)));




// WEBPACK FOOTER //
// src/main/content/dashboard/widgets/QuizGradeList.js